import { render, staticRenderFns } from "./deductionRecordList.vue?vue&type=template&id=75b510b3&scoped=true"
import script from "./deductionRecordList.vue?vue&type=script&lang=js"
export * from "./deductionRecordList.vue?vue&type=script&lang=js"
import style0 from "./deductionRecordList.vue?vue&type=style&index=0&id=75b510b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b510b3",
  null
  
)

export default component.exports